import styled from 'styled-components'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  pb: [80, 80, 120],
  pt: [20],
  px: [5, 5, 20],
})`
  width: 100%;
  justify-content: center;
`

export const Content = styled.div`
  width: 100%;
`
